import { DisplayInfo, Table } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { useColumns } from '../hooks/useColumns';
import { DegreeDocumentFormValues } from '../types';
interface Props {
  degreeDocuments: (DegreeDocumentFormValues & { fieldId: string })[];
  remove: (index: number) => void;
}
export const TableDegreeDocuments = ({ degreeDocuments, remove }: Props) => {
  const { t } = useTranslation();
  const prefix = 'studyPlans.curriculum.degreeDocuments.table';
  const columns = useColumns({ remove });

  return (
    <Table
      isLoadingResults={false}
      data={degreeDocuments}
      columns={columns}
      noResultsText={
        <div className="d-flex justify-content-center align-items-center py-5">
          <DisplayInfo
            iconName="information"
            title={t(`${prefix}.noResults.title`)}
            textBody={t(`${prefix}.noResults.description`)}
            maxWidth="650px"
          />
        </div>
      }
    />
  );
};
